<div class="modal-header">
    <h4 class="modal-title">Resetear VoBo</h4>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>

<mat-dialog-content>
    <div class="modal-body">
        <form [formGroup]="form">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Fase</mat-label>
                <mat-select formControlName="fase">
                    <mat-option *ngFor="let fase of fases" [value]="fase.id">{{ fase.name }}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-100">
                <mat-label>VoBo</mat-label>
                <mat-select formControlName="vobo" multiple>
                    <mat-option *ngFor="let vobo of vobos" [value]="vobo.id">{{ vobo.area }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-checkbox formControlName="arte" class="mt-3">
                <mat-label>Resetear arte</mat-label>
            </mat-checkbox>
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Comentario</mat-label>
                <textarea matInput formControlName="comentario" rows="4"></textarea>
            </mat-form-field>
        </form>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancelar</button>
    <button mat-raised-button color="primary" (click)="enviar()" [disabled]="form.invalid">Enviar</button>
</mat-dialog-actions>